import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const spotify = defineConnector({
  identifier: "spotify",
  name: "Spotify",
  tagLine: "Music streaming platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.spotify\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an OAuth app in Spotify",
      items: [
        {
          kind: "markdown",
          content:
            "Go to the [Spotify Developer Dashboard](https://developer.spotify.com/dashboard) and click **'Create app'**.",
        },
      ],
    },
    {
      title: "Fill out the details",
      items: [
        {
          kind: "markdown",
          content: "Copy and paste the following information into the form:",
        },
        {
          kind: "copyable",
          label: "App name",
          value: "3B",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/spotify/callback",
        },
        {
          kind: "markdown",
          content:
            "Select **'Web API'** as the API you want to use, accept the terms, and click **'Save'**.",
        },
      ],
    },
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Click **'Settings'** on your newly created app to find your Client ID and Client Secret.",
        },
      ],
    },
    {
      title: "Enter OAuth credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Define scopes for this connection",
      items: [
        {
          kind: "markdown",
          content:
            "Add [scopes](https://developer.spotify.com/documentation/web-api/concepts/scopes) in a space separated list below.",
        },
        {
          kind: "input",
          label: "Scopes",
          placeholder: "user-read-private user-read-email",
          defaultValue: "user-read-private user-read-email",
          helperText: "Space separated list of desired scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
            { kind: "oauthConnection", field: "scopes" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.spotify.com/authorize",
    tokenEndpoint: () => "https://accounts.spotify.com/api/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.spotify.com/v1/me",
  },
});
